/**
 * Pure claim-state helpers (no network, no React), shared by the wallet page and the
 * chrome's wallet badges (Header, MobileBottomNav). Phase 6c.
 *
 * A claim row is the GET /api/deals/my-claims (and GET /api/wallet) item:
 * { redeemed, redeemed_at?, claimed_at, expires_at? }. Since Phase 6b my-claims also
 * returns redeemed claims, so a count of "codes in the wallet" must filter.
 */

/** Claims without `expires_at` (legacy rows) expire this long after `claimed_at`. */
export const DEAL_EXPIRATION_DAYS = 7;
const DAY_MS = 24 * 60 * 60 * 1000;

const toDate = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** When the claim stops working: `expires_at`, else claimed_at + 7 days, else null. */
export function claimExpiry(claim) {
  const explicit = toDate(claim?.expires_at);
  if (explicit) return explicit;
  const claimed = toDate(claim?.claimed_at);
  return claimed ? new Date(claimed.getTime() + DEAL_EXPIRATION_DAYS * DAY_MS) : null;
}

/** 'redeemed' | 'expired' | 'active'. Redeemed wins over expired. */
export function claimState(claim, now = new Date()) {
  if (claim?.redeemed === true || claim?.redeemed_at) return 'redeemed';
  if (claim?.expired === true) return 'expired';
  const expires = claimExpiry(claim);
  return expires && expires <= now ? 'expired' : 'active';
}

export const isActiveClaim = (claim, now = new Date()) => !!claim && claimState(claim, now) === 'active';

/** Active (unredeemed, unexpired) claims in a my-claims list; 0 for anything else. */
export const countActiveClaims = (claims, now = new Date()) =>
  (Array.isArray(claims) ? claims.filter((c) => isActiveClaim(c, now)).length : 0);
